import { Injectable } from '@angular/core';
import {Subject} from 'rxjs/Subject';

@Injectable()
export class RefreshTokenService {
  public processing = false;
  public storage: Subject<any> = new Subject<any>();

  public publish(value: any) {
    this.storage.next(value);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/refresh-token.service.ts